import Vue from "vue";

export default {
    branding() {
        return Vue.http.get('branding');
    }
}